module.exports = __webpack_public_path__ + "img/clock.acddc73a.svg";